module.exports = __webpack_public_path__ + "static/img/智能报账5.a2e18a51.png";